module.exports = __webpack_public_path__ + "img/salon3.62efa478.jpg";